module.exports = __webpack_public_path__ + "static/media/camera.680bb16e.svg";